<template>
  <header class="sidd-chat-header">
    <div class="sidd-chat-header__content">
      <div class="sidd-chat-header__center"></div>

      <div class="sidd-chat-header__right">
        <ClearHistoryButton />
        <Button
          v-if="showSourcesButton"
          variant="ghost"
          size="icon"
          class="sidd-chat-header__source"
          @click="handleSource"
          :aria-label="sourceButtonLabel"
        >
          <FileText :size="20" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          class="sidd-chat-header__close"
          @click="handleClose"
          :aria-label="closeButtonLabel"
        >
          <X :size="20" />
        </Button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Button } from '@/lib/ui/button'
import { X, FileText } from 'lucide-vue-next'
import { useChatbot } from '@/composables/useChatbot'
import ClearHistoryButton from './ClearHistoryButton.vue'
import type {
  IHeaderPublicWidgetProps,
  IHeaderPublicWidgetEmits,
} from './types'

defineProps<IHeaderPublicWidgetProps>()

const emit = defineEmits<IHeaderPublicWidgetEmits>()

const chatbot = useChatbot()

const showSourcesButton = computed(() => {
  return chatbot.store.configuration?.showSourceAttribution ?? false
})

const closeButtonLabel = computed(() => 'Close chat')
const sourceButtonLabel = computed(() => 'Show sources')

const handleClose = () => {
  emit('close')
}

const handleSource = () => {
  emit('source')
}
</script>

<style>
.sidd-chat-header__content {
  justify-content: flex-end;
  gap: 12px;
  max-width: 100%;
}

.sidd-chat-header__center {
  flex: 1;
  min-width: 0;
}

.sidd-chat-header__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
</style>
